import React from 'react';

import { useTranslation } from '@lt/localization';
import { Button, Throbber } from '@lt/components';

import ReviewCard from 'src/components/Reviews/ReviewCard/ReviewCard';
import NotEnoughReviews from 'src/components/Reviews/NotEnoughReviews';

import type { ReviewsProps } from '@lt/api/dist/methods/hotelReviews/types';
import styles from './reviewsList.module.css';

interface ReviewListProps {
  items: ReviewsProps[];
  showMore: () => void;
  isShowMoreReviews: boolean;
  isLoadingNew: boolean;
  hasReviewsSection: boolean;
}

export const ReviewList = ({
  items,
  isShowMoreReviews,
  showMore,
  isLoadingNew,
  hasReviewsSection,
}: ReviewListProps): JSX.Element | null => {
  const { t } = useTranslation();
  if (!hasReviewsSection) return <NotEnoughReviews isEmptyReviews />;

  const handleClick = () => {
    showMore();
  };

  return (
    <>
      <div className={styles.reviewsList}>
        {items.map((item) => (
          <ReviewCard
            className={styles.reviewsCard}
            key={item.id}
            id={item.id}
            content={item.content}
            name={item.name}
            createdAt={item.createdAt}
            averageRating={item.averageRating}
            avatarUrl={item.avatarUrl}
            answer={item.answer}
            answeredAt={item.answeredAt}
            reviewPlus={item.reviewPlus}
            reviewMinus={item.reviewMinus}
            title={item.title}
            images={item.images}
            tags={item.tags}
            isMobile={false}
            phrase={item.phrase}
          />
        ))}
        {hasReviewsSection && items.length < 3 && (
          <NotEnoughReviews isEmptyReviews={false} />
        )}
        {isShowMoreReviews && (
          <div className={styles.showMoreContainer}>
            <Button
              className={styles.buttonShowMore}
              onClick={handleClick}
              size="flex"
            >
              {isLoadingNew ? (
                <Throbber size={20} color="rgb(0, 122, 255)" />
              ) : (
                t('hotel.reviews.moreReviews')
              )}
            </Button>
          </div>
        )}
      </div>
    </>
  );
};

export default ReviewList;
